import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { ItemClassService } from './item-class.service';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { ColumnFilter, RequestData, SearchSort } from 'src/app/common/models/request-data.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { FloatingMenuOption } from 'src/app/common/components/master-floating-menu/model/master-floating-model';
import { SelectionModel } from '@angular/cdk/collections';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from 'src/app/common/components/search-filter/search-filter.component';
import { Router } from '@angular/router';
import { ItemClassModel } from './model/item-class.model';
import { MatDialog } from '@angular/material/dialog';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, SortDirection } from '@angular/material/sort';
import { DepartmentService } from '../../system/department/department.service';

@Component({
    selector: 'app-item-class',
    templateUrl: './item-class.component.html',
    styleUrls: ['./item-class.component.scss'],
    standalone: false
})
export class ItemClassComponent {

  itemClassList: ItemClassModel[]=[];
  showSearch: boolean = false;
  isLoading = true;
  IsDownloading = false;

  filter: FilterListItemModel[] = [
    {
      title: "Code",
      column: "ic.code",
    },
    {
      title: "Name",
      column: "ic.name",
    },
    {
      title: "Department",
      column: "ic.department_id",
      type: "list",
      values: [],
    },
    {
      title: "Super Class",
      column: "ic.super_class_id",
      type: "list",
      values: [],
    }, 
  ];
  displayedColumns = ['code', 'name', 'description', 'super_class_id','department_id','action'];
  pagingData = { length: 0, pageSize: 10, pageIndex: 0 };
  menuOption: FloatingMenuOption = {
    add: true,
    search: false,
    export: true,
    more: true
  }

  isHandset: boolean = false;
  searchColumFilter: SearchParam = {};
  columnSortData: SearchSort[] = [];
  selectedItem?: ItemClassModel;
  showSummaryPanel: boolean = false;
  selection = new SelectionModel<ItemClassModel>(true, []);
  dataSource = new MatTableDataSource(this.itemClassList);
  department_id: any;
  super_class_id: any;

 constructor(private breakpointObserver: BreakpointObserver,
  private itemClassService: ItemClassService,
  private departmentService:DepartmentService,

  public dialog: MatDialog,
  private snackBarService: SnackBarService,
  private router: Router,private stateManagerService:StateManagerService) {

  this.itemClassList = [];
}
 /**
   * initilaize the device model
   */
 ngOnInit(): void {
  this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
    if (state.matches) {
      this.isHandset = true;
    } else {
      this.isHandset = false;
    }
  });
 this.loadDepartmentList();
 this.loadSuperClassList();
}
  /** 
  * Set the datasource
  */
  setDataSource(itemClassList:ItemClassModel[]){
    this.dataSource=new MatTableDataSource(itemClassList);
    this.dataSource.sort=this.sort;
  }
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;
  ngAfterViewInit(): void {

    this.loadPreviousState();
  }

  /**
   * loads the previous state if exists
   */
  loadPreviousState(): void {

    var previousState = this.stateManagerService.getState(this.constructor.name);

    if (previousState !== undefined && this.searchFilter != undefined) {

      if (previousState.state.search.filters.scope) {
        this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
        this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
      }

      if (previousState.state.search.sort != undefined && previousState.state.search.sort.length > 0) {
        this.setSortColumn(previousState.state.search.sort[0].column,previousState.state.search.sort[0].order);
      }

      this.searchColumFilter = JSON.parse(JSON.stringify(previousState.state.search.filters));
      this.searchFilter.setSearchFilter(this.searchColumFilter,true);

    } else {
      this.setSortColumn('ic.name','asc');
      this.loadData();
    }

  }

  /**
   * Sets the sort column
   * @param column 
   * @param direction 
   */
  setSortColumn(column: string, direction: SortDirection): void {
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: column, order: direction});
    this.sort.sort({
      id: column,
      start: direction,
      disableClear: false,
    });
  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.itemClassList.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.itemClassList);
  }

  /**
   * Create sort order
   * @returns sort criteria
   */
  getSort(): SearchSort[] {
    return this.columnSortData;
  }

/**
   * Builds the request data to be send to API
   * @returns Request Data
   */
buildRequestData(): RequestData {
  let searchParam = this.getSearchParam();
  let requestData: RequestData = {
    search: {
      filters: {
        simpleSearch: searchParam.freeSearch,
        advSearch: [
          ...(searchParam.advSearch || []),
          ...this.getDefaultSearchParams(searchParam.advSearch),
        ],
        scope: {
          limit: this.pagingData.pageSize,
          offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
        }
      },
      sort: this.getSort(),
    }
  };

  return requestData;
}

/**
 * Check and apply default filter for is_system = 0.
 **/
getDefaultSearchParams(searchFilter: any): ColumnFilter[] {
  var defFilter: any = [];
  if (
    searchFilter == undefined ||
    !searchFilter.some((sf: any) => sf.column == "ic.is_system")
  ) {
    defFilter.push({
      column: "ic.is_system",
      operator: "=",
      value: "0",
    });
  }
  return defFilter;
}

 /**
   * Set the column filter and reaload the daaa
   * @param columFilter 
   */

 onFilterApplied(columFilter: any): void {
  this.searchColumFilter = columFilter;
  this.loadData();

}

 /**
   * On delete menu item selected
   * Confirm the action and call the api to update
   */
 onDelete(ItemClassInfo: ItemClassModel): void {
  const itemClassId = ItemClassInfo.id;
  const message = `Are you sure, you want to delete ` + (ItemClassInfo.name + "?");
  const dialogData = new ConfirmDialogModel("Confirm Deletion", message);

  const dialogRef = this.dialog.open(ConfirmDialogComponent, {
    maxWidth: "400px",
    data: dialogData
  });

  dialogRef.afterClosed().subscribe(dialogResult => {
    console.log(dialogResult);
    if (dialogResult) {
      this.itemClassService.delete(ItemClassInfo).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            // handle success
            let snckBarData: SnackBarData = {
              type: 'success',
              title: 'Saved',
              message: 'The record for ' + ItemClassInfo.name + " has been deleted succesfully."
            }
            this.snackBarService.openSnackBar(snckBarData);
            this.loadData();
          } else {
            let snackBarData: SnackBarData = {
              message: "You cannot delete, this data is used somewhere else!",
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        },
        error: (error) => {
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });
    }
  });
}
loadDepartmentList(): void {
  let requestData = {
    search: {
      filters: {
        column: [],
        scope: { limit: 100, offset: 0 },
      },
      sort: [{ column: "code", order: "asc" }],
    },
  };

  this.departmentService.getDepartmentList(requestData).subscribe(
    (response: {
      status: string;
      data: {
        departments: any;
        code: any[];
        base_uom_id: any[];
      };
      message: any;
    }) => {
      if (response.status === "SUCCESS") {
        this.department_id = response.data.departments;
        this.filter[2].values = this.department_id.map((dept: any) => {
          return { title: dept.name, value: dept.id };
        });
      } else {
        let snackBarData: SnackBarData = {
          message: response.message,
          title: "Failed!!!",
          type: "error",
        };
        this.snackBarService.openSnackBar(snackBarData);
      }
    }
  );
}

/**
 * Load super class list for filter dropdown
 */
loadSuperClassList(): void {
  let requestData = {
    search: {
      filters: {
        column: [],
        scope: { limit: 100, offset: 0 },
      },
      sort: [{ column: "name", order: "asc" }],
    },
  };

  this.itemClassService.getParentClass(requestData).subscribe({
    next: (response: any) => {
      if (response.status === "SUCCESS") {
        this.super_class_id = response.data.super_classes || response.data.item_classes || response.data;
        this.filter[3].values = this.super_class_id.map((superClass: any) => {
          return { 
            title: superClass.name || superClass.className || superClass.title, 
            value: superClass.id 
          };
        });
      } else {
        let snackBarData: SnackBarData = {
          message: response.message,
          title: "Failed to load super classes!!!",
          type: "error",
        };
        this.snackBarService.openSnackBar(snackBarData);
      }
    },
    error: (error) => {
      let snackBarData: SnackBarData = {
        message: 'Failed to load super classes. Connection to the server failed',
        title: 'Failed!!!',
        type: 'error'
      };
      this.snackBarService.openSnackBar(snackBarData);
    }
  });
}



/**
 * loads the data based on the conditions
 */
loadData(): void {
  this.isLoading = true;
  let requestData = this.buildRequestData();
  let response = this.itemClassService.getList(requestData).subscribe(response => {
    if (response.status == 'SUCCESS') {
      this.itemClassList = response.data.item_classes;
      this.setDataSource(this.itemClassList);

      this.pagingData.length = response.data.total_count;
      if (this.pagingData.length == 0) {
        let snackBarData: SnackBarData = {
          message: 'No data found. Please remove or change the filter if any.',
          title: 'No Data!!!',
          type: 'warn'
        }
        this.snackBarService.openSnackBar(snackBarData);
        this.selectedItem = undefined;
      } else {
        this.onRowSelected(this.itemClassList[0]);
        this.stateManagerService.setState(this.constructor.name, requestData);

      }
    } else {
      let snackBarData: SnackBarData = {
        message: response.message,
        title: 'Failed!!!',
        type: 'error'
      }
      this.snackBarService.openSnackBar(snackBarData);
    }
    this.isLoading = false;
  });

}


 /**
 * On itemclass selected
 * @param ItemClassInfo 
 */
 onRowSelected(ItemClassInfo: ItemClassModel): void {
  this.selectedItem = ItemClassInfo;
  this.showSummaryPanel = true;
}

 /**
   *  Set the sort param and relead the data
 * @param $event sort data
 * {"active": "email","direction": "asc"}
 *   
   */
 sortData($event: any): void {
  var sd=this.sort;
  this.columnSortData.length = 0;
  this.columnSortData.push({ column: sd.active, order: sd.direction });
  this.loadData();
}
  /**
* Creates the column filter conditions based on search criteria
* @returns Filter condions for columns
*/
getSearchParam(): SearchParam {

  return this.searchColumFilter;
}

  /**
 * On edit the item
 * Show the edit dialog
 */
  onEdit(ItemClassInfo: ItemClassModel): void {

    this.router.navigate(['/product/item-class-edit', ItemClassInfo.id]);
  }

  
  /**
   * 
   * @param event 
   * When page size is changed update paging data
   */
  onePageEvent(event: any): void {

    this.pagingData.pageIndex = event.pageIndex;
    this.pagingData.pageSize = event.pageSize;

    this.loadData();

  }

  /**
   * On Add clicked
   * Show the dialog to enter new item class
   */
  addClicked(): void {

    this.router.navigate(['/product/item-class-edit', 0]);

  }
  exportClicked() {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    this.IsDownloading = true;
    this.itemClassService.downloadExcel(requestData)
      .subscribe({
        next: blob => {
          // Download logic
          this.IsDownloading = false;
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'itemclass.csv'; // Adjust filename if needed
          link.click();
          window.URL.revokeObjectURL(url);
          this.isLoading = false;


        },
        error: error => {
          // Handle errors
          this.IsDownloading = false;
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.isLoading = false;
          // Display user-friendly error message to the user
        }
      }
      );
  }

}